import { css } from '@emotion/react';
import { t } from 'i18n';

import { theme } from './theme';

const styles = {
  container: css`
    margin-top: 8.5rem;
    text-align: center;
  `,
  title: css`
    margin-bottom: ${theme.spacing.md};
  `,
  paragraph: css`
    margin-bottom: ${theme.spacing.lg};
  `,
};

export const GlobalErrorPage = () => {
  return (
    <div css={styles.container}>
      <h2 css={styles.title}>{t('error.generic.title', { defaultValue: 'Unfortunately, something went wrong' })}</h2>
      <p css={styles.paragraph}>{t('error.generic.message', { defaultValue: 'Please try to reload the page.' })}</p>
      <button
        onClick={() => {
          location.reload();
        }}
      >
        {t('error.generic.button', { defaultValue: 'Please try again.' })}
        <svg className="sas-icon" role="presentation">
          <use href="#cl--reload" />
        </svg>
      </button>
    </div>
  );
};
